import shcaUtils from './shcaUtils';

var K_SSK_CLIENT_VERSION = '0.8.7c';

var K_SHCA_CMD_GETVER = 'getVer';
var K_SHCA_CMD_GETSEAL = 'getSeal';
var K_SHCA_CMD_GETCERT = 'getCert';
var K_SHCA_CMD_GETCERTCHAIN = 'getChain';
var K_SHCA_CMD_GENRANDOM = 'genRandom';
var K_SHCA_CMD_SIGN = 'signData';
var K_SHCA_CMD_VERIFY = 'verifyData';
var K_SHCA_CMD_ENC_ENV = 'encEnv';
var K_SHCA_CMD_DEC_ENV = 'decEnv';
var K_SHCA_CMD_DOHASH = 'doHash';
var K_SHCA_CMD_LISTPLUGIN = 'listPlugin';
var K_SHCA_CMD_GETVERSION = 'getVersion';
var K_SHCA_CMD_GETCERTDETAIL = 'getDetail';
var K_SHCA_CMD_GETINFOBYOID = 'getInfoByOID';
var K_SHCA_CMD_SAVELOGINSTATE = 'saveLoginState';
var K_SHCA_CMD_GETLOGINSTATE = 'getLoginState';
var K_SHCA_CMD_CLEARLOGINSTATE = 'clearLoginState';

var K_SHCA_ASYMID_RSA = 1;
var K_SHCA_ASYMID_SM2 = 2;

var K_SHCA_USAGE_ENC = 1;
var K_SHCA_USAGE_SIGN = 2;

var myShcaSecKit;

var shcaSecKit = function(callback) {
  var wss4seCtrl = {};
  var myCbkFunc = callback;
  var myFunc = callback;
  var isLocked = false;
  var gCryptoDevice = {};

  this.initService = function(cfg) {

    if (shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      try {
        wss4seCtrl = new WebSocket('ws://127.0.0.1:18454');
      } catch (e) {
        if (isff && ishttps) {
        }
        return;
      }

      wss4seCtrl.onopen = function() {
        shcaSecKit.getInstance().listPlugin(cfg);
      };

      wss4seCtrl.onerror = function(e) {
        shcaUtils.alert({
          Text: '请运行或安装最新版协卡助手，点击下载<a href=\'https://www.962600.com/resources/tools\' target=\'_blank\' style=\'color:blue\'>协卡助手</a><br/>允许本网站弹出的所有加载项！',
          width: 350,
          dangerouslyUseHTMLString: true,
          height: 150,
        });
        console.log('onerror4seCtrl');
        wss4seCtrl = {};
      };

      wss4seCtrl.onmessage = function(msg) {
        isLocked = false;
        var ret = eval('(' + shcaUtils.forgetZero(msg.data) + ')');
        myFunc(ret);
      };

      wss4seCtrl.onclose = function(e) {
        console.log('onclose4seCtrl');
        wss4seCtrl = {};
      };
    } else {
      this.listPlugin(cfg);
    }
  };

  this.initServiceEn = function(cfg) {
    if (shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      try {
        wss4seCtrl = new WebSocket('ws://127.0.0.1:18454');
      } catch (e) {
        if (isff && ishttps) {
        }
        return;
      }

      wss4seCtrl.onopen = function() {
        shcaSecKit.getInstance().listPlugin(cfg);
      };

      wss4seCtrl.onerror = function(e) {
        shcaUtils.alert({
          Text: 'Please run or install the lastest version of the \'SHECA Assistant\'. Click to download <a href=\'https://www.962600.com/resources/tools\'> the \'SHECA Assistant\'</a>.<br/>Allow all the add-ins that pop up on this website',
          width: 350,
          height: 150,
        });
        console.log('onerror4seCtrl');
        wss4seCtrl = {};
      };

      wss4seCtrl.onmessage = function(msg) {
        isLocked = false;
        var ret = eval('(' + shcaUtils.forgetZero(msg.data) + ')');
        myFunc(ret);
      };

      wss4seCtrl.onclose = function(e) {
        console.log('onclose4seCtrl');
        wss4seCtrl = {};
      };
    } else {
      this.listPlugin(cfg);
    }
  };

  this.closeService = function() {
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      wss4seCtrl.close();
    } else {
      console.log('invaild handle.');
    }
  };

  this.setCryptoDevice = function(msg) {
    gCryptoDevice.devType = msg.devType;
    gCryptoDevice.devParam = msg.devParam;
    gCryptoDevice.asymid = msg.asymid;
    gCryptoDevice.usage = msg.usage;
  };

  this.c_ver = function() {
    return K_SSK_CLIENT_VERSION;
  };

  this.s_ver = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_GETVER;
    myFunc = (!msg.res) ? myCbkFunc : msg.res;
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (!isLocked) {
        wss4seCtrl.send(JSON.stringify(req));
        isLocked = true;
      } else {
        myFunc({
          key: req.key,
          ret: SE_ERROR_SERVICE_ISBUSY,
        });
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.listPlugin = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_LISTPLUGIN;
    req.asymid = msg.asymid;
    req.usage = msg.usage;
    myFunc = (!msg.res) ? myCbkFunc : msg.res;
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (!isLocked) {
        wss4seCtrl.send(JSON.stringify(req));
        isLocked = true;
      } else {
        myFunc({
          key: req.key,
          ret: SE_ERROR_SERVICE_ISBUSY,
        });
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.sign = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_SIGN;
    if (msg.isHex) {
      req.val = msg.data;
    } else {
      var b64_engine = new Base64();
      req.val = b64_engine.encode(msg.data);
    }
    req.itemNo = (!msg.algid) ? 3 : msg.algid;
    req.pwd = msg.pwd;
    req.devType = gCryptoDevice.devType;
    req.devParam = gCryptoDevice.devParam;
    req.asymid = gCryptoDevice.asymid;
    req.usage = gCryptoDevice.usage;
    myFunc = (!msg.res) ? myCbkFunc : msg.res;
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (!isLocked) {
        wss4seCtrl.send(JSON.stringify(req));
        isLocked = true;
      } else {
        myFunc({
          key: req.key,
          ret: SE_ERROR_SERVICE_ISBUSY,
        });
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.verifySign = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_VERIFY;
    if (msg.isHex) {
      req.val = msg.data;
    } else {
      var b64_engine = new Base64();
      req.val = b64_engine.encode(msg.data);
    }
    req.itemNo = (!msg.algid) ? 3 : msg.algid;
    req.cert = msg.cert;
    req.oid = msg.signdata;
    myFunc = (!msg.res) ? myCbkFunc : msg.res;
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (!isLocked) {
        wss4seCtrl.send(JSON.stringify(req));
        isLocked = true;
      } else {
        myFunc({
          key: req.key,
          ret: SE_ERROR_SERVICE_ISBUSY,
        });
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.getSeal = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_GETSEAL;
    req.itemNo = (!msg.type) ? 2 : msg.type;
    req.devType = gCryptoDevice.devType;
    req.devParam = gCryptoDevice.devParam;
    myFunc = (!msg.res) ? myCbkFunc : msg.res;
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (!isLocked) {
        wss4seCtrl.send(JSON.stringify(req));
        isLocked = true;
      } else {
        myFunc({
          key: req.key,
          ret: SE_ERROR_SERVICE_ISBUSY,
        });
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.getCert = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_GETCERT;
    req.devType = gCryptoDevice.devType;
    req.devParam = gCryptoDevice.devParam;
    req.asymid = (!msg.asymid) ? (gCryptoDevice.asymid) : (msg.asymid);
    req.usage = (!msg.usage) ? (gCryptoDevice.usage) : (msg.usage);
    myFunc = (!msg.res) ? (myCbkFunc) : (msg.res);
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (!isLocked) {
        wss4seCtrl.send(JSON.stringify(req));
        isLocked = true;
      } else {
        myFunc({
          key: req.key,
          ret: SE_ERROR_SERVICE_ISBUSY,
        });
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.getCertchain = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_GETCERTCHAIN;
    req.devType = gCryptoDevice.devType;
    req.devParam = gCryptoDevice.devParam;
    req.asymid = (!msg.asymid) ? (gCryptoDevice.asymid) : (msg.asymid);
    myFunc = (!msg.res) ? myCbkFunc : msg.res;
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (!isLocked) {
        wss4seCtrl.send(JSON.stringify(req));
        isLocked = true;
      } else {
        myFunc({
          key: req.key,
          ret: SE_ERROR_SERVICE_ISBUSY,
        });
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.hash = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_DOHASH;
    req.itemNo = msg.algid;
    myFunc = (!msg.res) ? myCbkFunc : msg.res;
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (!isLocked) {
        wss4seCtrl.send(JSON.stringify(req));
        isLocked = true;
      } else {
        myFunc({
          key: req.key,
          ret: SE_ERROR_SERVICE_ISBUSY,
        });
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.getCertDetail = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_GETCERTDETAIL;
    req.itemNo = msg.itemNo;
    req.cert = msg.cert;
    myFunc = (!msg.res) ? myCbkFunc : msg.res;
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (!isLocked) {
        wss4seCtrl.send(JSON.stringify(req));
        isLocked = true;
      } else {
        myFunc({
          key: req.key,
          ret: SE_ERROR_SERVICE_ISBUSY,
        });
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.getCertInfoByOID = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_GETINFOBYOID;
    req.oid = msg.oid;
    req.cert = msg.cert;
    myFunc = (!msg.res) ? (myCbkFunc) : (msg.res);
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (!isLocked) {
        wss4seCtrl.send(JSON.stringify(req));
        isLocked = true;
      } else {
        myFunc({
          key: req.key,
          ret: SE_ERROR_SERVICE_ISBUSY,
        });
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.saveLoginState = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_SAVELOGINSTATE;
    req.val = 'sn=' + msg.sn;
    myFunc = (!msg.res) ? myCbkFunc : msg.res;
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (req.val.length > 64) {
        //SN is invaild
        myFunc({
          key: req.key,
          ret: SE_ERROR_PARAM,
        });
      } else {
        if (!isLocked) {
          wss4seCtrl.send(JSON.stringify(req));
          isLocked = true;
        } else {
          myFunc({
            key: req.key,
            ret: SE_ERROR_SERVICE_ISBUSY,
          });
        }
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.getLoginState = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_GETLOGINSTATE;
    req.val = 'sn=' + msg.sn;
    myFunc = (!msg.res) ? myCbkFunc : msg.res;
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (req.val.length > 64) {
        //SN is invaild
        myFunc({
          key: req.key,
          ret: SE_ERROR_PARAM,
        });
      } else {
        if (!isLocked) {
          wss4seCtrl.send(JSON.stringify(req));
          isLocked = true;
        } else {
          myFunc({
            key: req.key,
            ret: SE_ERROR_SERVICE_ISBUSY,
          });
        }
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };

  this.clearLoginState = function(msg) {
    var req = {};
    req.key = K_SHCA_CMD_CLEARLOGINSTATE;
    req.val = 'sn=' + msg.sn;
    myFunc = (!msg.res) ? myCbkFunc : msg.res;
    if (!shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      if (req.val.length > 64) {
        //SN is invaild
        myFunc({
          key: req.key,
          ret: SE_ERROR_PARAM,
        });
      } else {
        if (!isLocked) {
          wss4seCtrl.send(JSON.stringify(req));
          isLocked = true;
        } else {
          myFunc({
            key: req.key,
            ret: SE_ERROR_SERVICE_ISBUSY,
          });
        }
      }
    } else {
      myFunc({
        key: req.key,
        ret: SE_ERROR_INITIAL_SERVICE,
      });
    }
  };
};

shcaSecKit.getInstance = function(callback) {
  myShcaSecKit = myShcaSecKit || {};
  if (shcaUtils.isEmptyOfObject(myShcaSecKit)) {
    myShcaSecKit = new shcaSecKit(callback);
  }
  return myShcaSecKit;
};

var SE_SUCCESS = 0;
var SE_ERROR_PRIVATE_KEY_PASSWORD = 0x82040003;

var SE_ERROR_CHANGE_PASS = 0x8204005E;
var SE_ERROR_VERIFY_SIGN = 0x8204000D;
var SE_ERROR_CERT_EXPIRED = 0x82040012;
var SE_ERROR_GET_CERT_DETAIL = 0x82040021;
var SE_ERROR_PARAM = 0x8204005B;
var SE_ERROR_INITIAL_SERVICE = 0x820400E0;
var SE_ERROR_SERVICE_ISBUSY = 0x820400E1;

var K_SYM_128BIT_SK_LEN = 16;
var K_SYM_AES_SK_BIT_LEN = 256;
var K_RSA_1024_OPRA_PEM_LEN = 256;

/********************************************************�°�֤������ukey��¼**************************************/
var shcaSecKitNew = function(callback) {
  var wss4seCtrl = {};
  this.initServiceNew = function(cfg) {
    if (shcaUtils.isEmptyOfObject(wss4seCtrl)) {
      try {
        wss4seCtrl = new WebSocket('ws://127.0.0.1:18455');
      } catch (e) {
        console.log('error' + e);
        if (isff && ishttps) {
          shcaUtils.alert({
            Text: '当前环境需进行如下设置才可正常使用<br/>1、在本页面点击"客户端工具"下载安装证书助手<br/>2、在浏览器地址栏中输入"about:config"进入设置页面<br/>3、找到"network.websocket.allowInsecureFromHTTPS"双击切换为true',
            width: 350,
            height: 150,
          });
        }
        return;
      }
      wss4seCtrl.onopen = function() {};

      wss4seCtrl.onerror = function(e) {
        shcaUtils.alert({
          Text: '请在本页面点击“客户端工具”下载安装证书助手后重试!',
          width: 350,
          height: 150,
        });
        console.log('onerror4seCtrl');
        wss4seCtrl = {};
        return;
      };

      wss4seCtrl.onmessage = function(msg) {};

      wss4seCtrl.onclose = function(e) {
        console.log('onclose4seCtrl');
        wss4seCtrl = {};
      };
    }
  };
};

shcaSecKitNew.getInstance = function(callback) {
  myShcaSecKit = myShcaSecKit || {};
  if (shcaUtils.isEmptyOfObject(myShcaSecKit)) {
    myShcaSecKit = new shcaSecKitNew(callback);
  }
  return myShcaSecKit;
};

// if (typeof module != 'undefined' && module.exports) module.exports = shcaSecKit; //CommonJs export

export default shcaSecKit;



//////////////////
// WEBPACK FOOTER
// ./static/lib/js/shcaSecKit.js
// module id = HV/v
// module chunks = 3